module.exports = __webpack_public_path__ + "img/ore-gold.e67dd5f7.svg";